module.exports = __webpack_public_path__ + "e8652d74837411100bb99537b9d397e2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/the economist.png
// module id = Dqrn
// module chunks = 0